import React from 'react'
import { connectRange } from 'react-instantsearch-dom'
import { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import Slider from '@material-ui/core/Slider'
import { Tooltip } from '@material-ui/core'
import colors from '@bit/atd.web.colors/dist/colors'
import FilterResults from '../FilterResults'

const CustomSlider = withStyles({
  root: {
    color: colors.brandOrange,
    // height: 4,
    maxWidth: '90%',
    boxSizing: 'border-box',
  },
  thumb: {
    height: 16,
    width: 16,
    backgroundColor: '#fff',
    border: '4px solid currentColor',
    // transform: 'translateY(-25%)',
    marginLeft: 0,
    '&:focus, &:hover, &$active': {
      boxShadow: 'inherit',
    },
  },
  active: {},
  valueLabel: {
    // left: 'calc(-50% + 4px)',
  },
  markLabel: {
    transform: 'none',
    padding: '3px',
  },
  track: {
    height: 4,
    borderRadius: 4,
  },
  rail: {
    height: 4,
    borderRadius: 4,
  },
})(Slider)

type ValueLabelProps = {
  children: React.ReactElement
  open: boolean
  value: number
}

function ValueLabelComponent(props: ValueLabelProps) {
  const { children, open, value } = props

  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  )
}

type PropsType = {
  min: number
  max: number
  currentRefinement: { min: number; max: number } & any
  canRefine: boolean
  refine: any
  transformValue?: (value: number | string) => string
}
const RangeSlider = (props: PropsType) => {
  const { min, max, refine, canRefine, transformValue }: PropsType = props
  const currentRefinement: { min: number; max: number } =
    props.currentRefinement
  const [value, setValue] = useState<number[]>([
    currentRefinement.min,
    currentRefinement.max,
  ])

  const handleChange = (event: unknown, newValue: number | number[]) => {
    setValue(newValue as number[])
  }

  useEffect(() => {
    if (canRefine) {
      /*    &&
      (min !== currentRefinement.min || max !== currentRefinement.max)
    )*/ setValue(
        [currentRefinement.min, currentRefinement.max],
      )
    }
  }, [currentRefinement, canRefine])

  const onChange = (event: unknown, newValue: number | number[]): void => {
    if (!Array.isArray(newValue)) {
      return
    }
    if (
      currentRefinement.min !== newValue[0] ||
      currentRefinement.max !== newValue[1]
    ) {
      refine({
        min: newValue[0],
        max: newValue[1],
      })
    }
  }

  function valuetext(value: number) {
    return `${value}`
  }

  const marks = [
    {
      value: min,
      label: transformValue ? transformValue(min) : min,
    },
    {
      value: max,
      label: transformValue ? transformValue(max) : max,
    },
  ]

  return (
    <FilterResults>
      {min === max ? (
        <div>no options available</div>
      ) : (
        <CustomSlider
          ValueLabelComponent={ValueLabelComponent}
          value={value}
          onChange={handleChange}
          onChangeCommitted={onChange}
          valueLabelDisplay="auto"
          aria-labelledby="range-slider"
          getAriaValueText={valuetext}
          valueLabelFormat={(value) =>
            transformValue ? transformValue(value) : value
          }
          min={min}
          max={max}
          marks={marks}
        />
      )}
    </FilterResults>
  )
}

export default connectRange(RangeSlider)
